import { render, staticRenderFns } from "./EnterpriseAnnouncement.vue?vue&type=template&id=29463675&"
import script from "./EnterpriseAnnouncement.vue?vue&type=script&lang=js&"
export * from "./EnterpriseAnnouncement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports